import React from 'react';
import Add from '@material-ui/icons/Add'
import { IconButton } from '@material-ui/core';
import { FlexContainer, TitleH6 } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';
import 'styled-components/macro'


function AddItem({translate, onClick, margin, marginTitle, showTitle=true}) {
    const { t } = useTranslation()

    return (
        <FlexContainer
            justifyContent='flex-end'
            width='100%'
            alignItems='center' 
            margin= {margin || '0 2rem'}
            >
        <IconButton
            data-cy='add-entity'
            aria-label="delete"
            onClick={onClick}
        >
            <Add fontSize="small" />
        </IconButton>
            {showTitle && <TitleH6 
                value={t(translate)}
                css={`font-weight:500; color:${props => props.theme.colors.main}; cursor: pointer;`} 
                onClick={onClick}
                margin={marginTitle && marginTitle}
            />}
        </FlexContainer>
    );
}

export { AddItem }